export default __webpack_public_path__ + "static/media/mitsubishi.5721e1b1.webp";